import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component
 * 
 * Automatically scrolls the window to the top (0, 0) whenever the route pathname changes.
 * This ensures that when navigating to a new page, the user starts at the top of the content,
 * rather than maintaining the scroll position from the previous page.
 * 
 * It disables the browser's default scroll restoration to prevent conflicts and ensures
 * reliable positioning at the top of the page.
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    // Disable the browser's default scroll restoration to prevent it from
    // overriding our manual scroll to top. This is crucial for fixing inconsistencies
    // where the browser attempts to restore the previous scroll position on navigation.
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // Use 'instant' behavior to immediately jump to the top without smooth scrolling,
    // which can feel sluggish on page loads or conflict with layout transitions.
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
  }, [pathname, search]); // Re-run on search param changes (e.g. tabs)

  return null;
}
